import React from "react";

import styled from "styled-components/macro";

import { Tooltip } from "components/base";

export type ToggleButtonT = {
  children: React.ReactNode;
  tooltipText?: React.ReactNode | string;
  value: boolean;
  onClick: () => void;
  showBorder?: boolean;
  disabled?: boolean;
  padding?: number | string;
};

const ToggleButton = ({
  children,
  tooltipText = "",
  value,
  onClick,
  showBorder = false,
  disabled = false,
  padding,
  ...props
}: ToggleButtonT) => {
  return (
    <Tooltip title={tooltipText}>
      <span style={{ display: "inline-flex" }}>
        <StyledButton
          {...props}
          isActive={value}
          onClick={disabled ? undefined : onClick}
          showBorder={showBorder}
          disabled={disabled}
          $padding={padding}>
          {children}
        </StyledButton>
      </span>
    </Tooltip>
  );
};

export default ToggleButton;

const StyledButton = styled.button<{ $padding?: number | string }>`
  height: 32px;
  padding: 0
    ${(props) =>
      props.$padding !== undefined
        ? typeof props.$padding === "number"
          ? `${props.$padding}px`
          : props.$padding
        : "6px"};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: ${(props) => (props.showBorder ? "1px solid" : "none")};
  border-color: ${(props) => (props.isActive ? "var(--color-primary)" : "#d9d9d9")};
  border-radius: var(--border-radius);
  box-shadow: none;
  color: ${(props) =>
    props.disabled ? "#ddd" : props.isActive ? "var(--color-primary)" : "#a2aaad"};
  transition: color 0.15s;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  &:hover {
    color: ${(props) => (props.disabled ? "#ddd" : "var(--color-primary)")};
    border-color: var(--color-primary);
  }

  & > svg {
    cursor: inherit;
  }
`;
